@file:OptIn(InternalResourceApi::class)

package rainbowclubs.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/rainbowclubs.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_801_743_962)
internal val Res.string.search_icon_cd: StringResource by lazy {
      StringResource("string:search_icon_cd", "search_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1448, 30),
      ))
    }

@delegate:ResourceContentHash(-1_424_265_627)
internal val Res.string.search_members: StringResource by lazy {
      StringResource("string:search_members", "search_members", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9499, 42),
      ))
    }

@delegate:ResourceContentHash(-318_786_703)
internal val Res.string.select_club_screen_name: StringResource by lazy {
      StringResource("string:select_club_screen_name", "select_club_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9542, 47),
      ))
    }

@delegate:ResourceContentHash(-571_543_080)
internal val Res.string.select_date: StringResource by lazy {
      StringResource("string:select_date", "select_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9590, 35),
      ))
    }

@delegate:ResourceContentHash(1_328_995_505)
internal val Res.string.select_event_to_edit: StringResource by lazy {
      StringResource("string:select_event_to_edit", "select_event_to_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9626, 60),
      ))
    }

@delegate:ResourceContentHash(1_811_613_369)
internal val Res.string.select_field_type: StringResource by lazy {
      StringResource("string:select_field_type", "select_field_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9687, 33),
      ))
    }

@delegate:ResourceContentHash(1_770_185_005)
internal val Res.string.select_from_list: StringResource by lazy {
      StringResource("string:select_from_list", "select_from_list", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9721, 48),
      ))
    }

@delegate:ResourceContentHash(1_813_438_755)
internal val Res.string.send_comment: StringResource by lazy {
      StringResource("string:send_comment", "send_comment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9770, 28),
      ))
    }

@delegate:ResourceContentHash(1_615_405_930)
internal val Res.string.shield_icon_cd: StringResource by lazy {
      StringResource("string:shield_icon_cd", "shield_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1479, 38),
      ))
    }

@delegate:ResourceContentHash(280_690_581)
internal val Res.string.show_password: StringResource by lazy {
      StringResource("string:show_password", "show_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9799, 41),
      ))
    }

@delegate:ResourceContentHash(-397_079_992)
internal val Res.string.signup_button: StringResource by lazy {
      StringResource("string:signup_button", "signup_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9841, 41),
      ))
    }

@delegate:ResourceContentHash(2_000_772_858)
internal val Res.string.signup_screen_name: StringResource by lazy {
      StringResource("string:signup_screen_name", "signup_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9883, 46),
      ))
    }

@delegate:ResourceContentHash(1_850_445_373)
internal val Res.string.splash_screen_name: StringResource by lazy {
      StringResource("string:splash_screen_name", "splash_screen_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9930, 46),
      ))
    }

@delegate:ResourceContentHash(-1_247_489_008)
internal val Res.string.start_fresh: StringResource by lazy {
      StringResource("string:start_fresh", "start_fresh", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9977, 35),
      ))
    }

@delegate:ResourceContentHash(-1_273_295_237)
internal val Res.string.submit_my_data: StringResource by lazy {
      StringResource("string:submit_my_data", "submit_my_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10013, 42),
      ))
    }

@delegate:ResourceContentHash(951_346_078)
internal val Res.string.take_attendance: StringResource by lazy {
      StringResource("string:take_attendance", "take_attendance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10128, 43),
      ))
    }

@delegate:ResourceContentHash(-1_819_267_518)
internal val Res.string.take_attendance_description: StringResource by lazy {
      StringResource("string:take_attendance_description", "take_attendance_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10056, 71),
      ))
    }

@delegate:ResourceContentHash(-1_910_449_398)
internal val Res.string.try_again_button: StringResource by lazy {
      StringResource("string:try_again_button", "try_again_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10172, 36),
      ))
    }

@delegate:ResourceContentHash(-1_063_434_279)
internal val Res.string.unsaved_changes: StringResource by lazy {
      StringResource("string:unsaved_changes", "unsaved_changes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10209, 43),
      ))
    }

@delegate:ResourceContentHash(-1_752_605_082)
internal val Res.string.upcoming_event: StringResource by lazy {
      StringResource("string:upcoming_event", "upcoming_event", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10253, 42),
      ))
    }

@delegate:ResourceContentHash(-1_955_141_916)
internal val Res.string.update: StringResource by lazy {
      StringResource("string:update", "update", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10374, 22),
      ))
    }

@delegate:ResourceContentHash(-1_731_591_457)
internal val Res.string.update_event_page_description: StringResource by lazy {
      StringResource("string:update_event_page_description", "update_event_page_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10296, 77),
      ))
    }

@delegate:ResourceContentHash(-541_421_964)
internal val Res.string.upload_image: StringResource by lazy {
      StringResource("string:upload_image", "upload_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10397, 36),
      ))
    }

@delegate:ResourceContentHash(1_182_225_372)
internal val Res.string.user_qr_code_cd: StringResource by lazy {
      StringResource("string:user_qr_code_cd", "user_qr_code_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1518, 39),
      ))
    }

@delegate:ResourceContentHash(706_270_858)
internal val Res.string.view_button: StringResource by lazy {
      StringResource("string:view_button", "view_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10434, 27),
      ))
    }

@delegate:ResourceContentHash(-117_342_523)
internal val Res.string.warning_icon_cd: StringResource by lazy {
      StringResource("string:warning_icon_cd", "warning_icon_cd", setOf(
        ResourceItem(setOf(), "${MD}values/content_description.commonMain.cvr", 1558, 39),
      ))
    }

@delegate:ResourceContentHash(-937_357_048)
internal val Res.string.welcome_back: StringResource by lazy {
      StringResource("string:welcome_back", "welcome_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10462, 52),
      ))
    }

@delegate:ResourceContentHash(-1_422_879_106)
internal val Res.string.you_are_admin: StringResource by lazy {
      StringResource("string:you_are_admin", "you_are_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10515, 45),
      ))
    }

@delegate:ResourceContentHash(-907_962_067)
internal val Res.string.your_clubs: StringResource by lazy {
      StringResource("string:your_clubs", "your_clubs", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10561, 34),
      ))
    }

@delegate:ResourceContentHash(1_348_921_442)
internal val Res.string.your_rsvp: StringResource by lazy {
      StringResource("string:your_rsvp", "your_rsvp", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10596, 29),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("search_icon_cd", Res.string.search_icon_cd)
  map.put("search_members", Res.string.search_members)
  map.put("select_club_screen_name", Res.string.select_club_screen_name)
  map.put("select_date", Res.string.select_date)
  map.put("select_event_to_edit", Res.string.select_event_to_edit)
  map.put("select_field_type", Res.string.select_field_type)
  map.put("select_from_list", Res.string.select_from_list)
  map.put("send_comment", Res.string.send_comment)
  map.put("shield_icon_cd", Res.string.shield_icon_cd)
  map.put("show_password", Res.string.show_password)
  map.put("signup_button", Res.string.signup_button)
  map.put("signup_screen_name", Res.string.signup_screen_name)
  map.put("splash_screen_name", Res.string.splash_screen_name)
  map.put("start_fresh", Res.string.start_fresh)
  map.put("submit_my_data", Res.string.submit_my_data)
  map.put("take_attendance", Res.string.take_attendance)
  map.put("take_attendance_description", Res.string.take_attendance_description)
  map.put("try_again_button", Res.string.try_again_button)
  map.put("unsaved_changes", Res.string.unsaved_changes)
  map.put("upcoming_event", Res.string.upcoming_event)
  map.put("update", Res.string.update)
  map.put("update_event_page_description", Res.string.update_event_page_description)
  map.put("upload_image", Res.string.upload_image)
  map.put("user_qr_code_cd", Res.string.user_qr_code_cd)
  map.put("view_button", Res.string.view_button)
  map.put("warning_icon_cd", Res.string.warning_icon_cd)
  map.put("welcome_back", Res.string.welcome_back)
  map.put("you_are_admin", Res.string.you_are_admin)
  map.put("your_clubs", Res.string.your_clubs)
  map.put("your_rsvp", Res.string.your_rsvp)
}
